import React, { useState, useEffect, useMemo, useRef } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Grid,
  Stack,
  Snackbar,
  TextField,
  Alert,
  Autocomplete,
  Typography,
} from "@mui/material";
import moment from "moment"; // PARA LA FECHA

//adjuntado
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR ARCHIVOS
import FileUploadStock from "./FileUploadStock";

//enviar mails
import { grey } from "@mui/material/colors";
import Title from "../Title";
import { logEventos } from "../../services/services";
import { getData } from "../../services/library";

function Dialog_ingresar(props) {
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [usuarioCompras, setUsuarioCompras] = useState([props.usuarioCompras]);
  const [datosArt, setDatosArt] = useState(props.datosArt)
  const [dialogCrearArticulo, setDialogCrearArticulo] = useState(props.dialogCrearArticulo);
  const [openCloseAdjDoc, setOpenCloseAdjDoc] = useState(false); //ADJUNTAR IMAGEN
  const [articuloSeleccionado, setArticuloSeleccionado] = useState({});
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState({});
  const [inventarioPrendas, setInventarioPrendas] = useState()
  const [talles, setTalles] = useState([])
  const [stockPorTalles, setStockPorTalles] = useState([]);
  const [errorCantidad, setErrorCantidad] = useState(false)


  const timeoutRef = useRef(null);

  //  sumar cantidad en ingreso
  const [cantidadInventario, setCantidadInventario] = useState(0);

  const handleCantidadInventario = (e) => {
    setCantidadInventario(e.target.value);
  };
  const [inventario, setInventario] = useState([]);

  // CALCULO DEL TOTAL FINAL
  useEffect(() => {
    setCantidadInventario(
      inventario[0]
        ? parseInt(inventario[0].cantidad) +
        parseInt(datosArt.cantidad_recibida)
        : null
    );
  }, [inventario, datosArt.cantidad_recibida]);


  //funcion para obtener sucursales
  const obtenerInventario = () => {
    fetch(
      UrlApi +
      "/stock_inventarios/xalmart/" +
      almacenSeleccionado.id_almacen +
      "/" +
      articuloSeleccionado.id_articulo
    )
      .then((data) => data.json())
      .then((data) => setInventario(data));
  };

  useEffect(() => {
    obtenerInventario();
  }, [almacenSeleccionado.id_almacen, articuloSeleccionado.id_articulo]);


  const guardarCrear = async (e) => {
    setErrorCantidad(true)
    logEventos("Guardar ingreso de artículo a sucursal", "Stock Sucursales", "Se guardo el ingreso", localStorage.getItem("user"))

    const reqData = {
      cuit_proveedor: proveedorSelected.cuit,
      id_accion: 158,
      id_transaccion: datosArt.id_transaccion,
      id_proveedor: proveedorSelected.padron === 0 ? proveedorSelected.id : null,
      id_articulo: articuloSeleccionado.id_articulo,
      almacen_destino: almacenSeleccionado.id_almacen,
      cantidad_recibida: datosArt.cantidad_recibida,
      detalle_transaccion: datosArt.detalle_transaccion,
      nro_remito_puntodeventa: datosArt.nro_remito_puntodeventa,
      nro_remito_numero: datosArt.nro_remito_numero,
      fecha_transaccion: moment(datosArt.fecha_transaccion).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      usuario: localStorage.getItem("user"),
      uuid_documentacion: props.newUuidDoc, //ADJUNTAR IMAGEN
      ...(proveedorSelected?.padron === 1 && {
        nuevoProveedor: {
          ...proveedorSelected,
          usuario: localStorage.getItem("user"),
          observaciones: "Proveedor cargado en ingreso de articulos por sucursal.",
        },
      }),
    }

    e.preventDefault();
    await fetch(UrlApi + "/stock_transacciones/anade_proveedor", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqData),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El artículo se guardó exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el artículo");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    // ------ { AGREGAR SEGUNDO GUARDAR (?) } ------
    e.preventDefault();
    if (inventario.length === 0) {
      await fetch(UrlApi + "/stock_inventarios", {
        // PUT SI YA EXISTE / POST SI ES NUEVO
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_articulo: articuloSeleccionado.id_articulo,
          cantidad: datosArt.cantidad_recibida,
          id_almacen: almacenSeleccionado.id_almacen,
          usuario: localStorage.getItem("user"),
        }),
      })
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
      // handleClickOpenCrear();
    } else {
      await fetch(
        UrlApi +
        "/stock_inventarios/" +
        almacenSeleccionado.id_almacen +
        "/" +
        articuloSeleccionado.id_articulo,
        {
          // PUT SI YA EXISTE / POST SI ES NUEVO
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cantidad: cantidadInventario,
            usuario: localStorage.getItem("user"),
          }),
        }
      )
        .then((res) => {
          if (!res.err) {
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El artículo se guardó exitosamente !");
          } else {
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    }


    // inventario por talles
    e.preventDefault();
    if (articuloSeleccionado.tiene_talles === 1) {
      for (let i = 0; i < stockPorTalles.length; i++) {
        const element = stockPorTalles[i];
        if (element.stock >= 0) {
          // Verifica si el talle ya existe en inventarioPrendas
          const talleExistente = inventarioPrendas.find(
            (item) => item.talle === element.id
          );

          // Configuración de la solicitud
          const url = talleExistente
            ? `${UrlApi}/stock_prendas/${talleExistente.id}` // PUT si existe
            : `${UrlApi}/stock_prendas`; // POST si no existe
          const metodo = talleExistente ? "PUT" : "POST";

          // Calcular la cantidad para el PUT
          const nuevaCantidad = talleExistente
            ? talleExistente.cantidad + element.stock // Suma la cantidad existente con la nueva
            : element.stock;

          // Realiza la solicitud
          try {
            const response = await fetch(url, {
              method: metodo,
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                almacen: almacenSeleccionado.id_almacen,
                articulo: articuloSeleccionado.id_articulo,
                talle: element.id,
                cantidad: nuevaCantidad, // En el PUT, es la suma
                usuario: localStorage.getItem("user"),
              }),
            });

            if (response.ok) {
              setOpenSnack(true);
              setColorMensaje("#D4EFDF");
              setMensaje(
                talleExistente
                  ? "El artículo se actualizó exitosamente!"
                  : "El artículo se guardó exitosamente!"
              );
            } else {
              throw new Error("Error al guardar el artículo");
            }
          } catch (error) {
            console.error(error.message);
            setOpenSnack(false);
            setColorMensaje("#F1948A");
            setMensaje("Error al guardar el artículo");
          }
        }
      }
    }

    // PARA LIMPIAR LOS DATOS
    handleClose();
  };

  const handleClose = () => {
    setDialogCrearArticulo(!dialogCrearArticulo)
    if (props.onClose) {
      props.onClose();
    }
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleOpenCloseAdjDoc = (value) => {
    setOpenCloseAdjDoc(value);
  };

  const almacenar = (e) => {
    setDatosArt({
      ...datosArt,
      [e.target.name]: e.target.value,
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const obtenerTalles = () => {
    getData("/stock_prendas_talles/tallesxprendaactivo/" + articuloSeleccionado.tipo_prenda, setTalles)
  };

  useEffect(() => {
    if (articuloSeleccionado && articuloSeleccionado.tiene_talles === 1) {
      obtenerTalles()
    }
  }, [articuloSeleccionado])

  useEffect(() => {
    // Inicializar stockPorTalles basado en los talles
    const initialStock = talles.map((talle) => ({ id: talle.id, stock: 0 }));
    setStockPorTalles(initialStock);
  }, [talles]); // Se ejecutará cada vez que `talles` cambie


  const handleStockChange = (id, newStock) => {
    const stockValue = Number(newStock);

    // Evitar valores inválidos
    if (isNaN(stockValue) || stockValue < 0) {
      return;
    }

    // Calcula la suma actual de los valores (excluyendo el que se está actualizando)
    const currentTotal = stockPorTalles.reduce((sum, item) => {
      return item.id === id ? sum : sum + item.stock;
    }, 0);

    // Valida que la suma no exceda datosArt.cantidad_recibida
    if (currentTotal + stockValue > datosArt.cantidad_recibida || currentTotal + stockValue < datosArt.cantidad_recibida) {
      setErrorCantidad(true);
    } else {
      setErrorCantidad(false);
    }

    // Actualiza el estado
    setStockPorTalles((prevStock) =>
      prevStock.map((item) =>
        item.id === id ? { ...item, stock: stockValue } : item
      )
    );
  };

  useEffect(() => {
    if (articuloSeleccionado?.tiene_talles === 1 && datosArt.cantidad_recibida > 0) {
      const totalAsignado = stockPorTalles.reduce((sum, item) => sum + item.stock, 0);

      // Valida que la suma no exceda datosArt.cantidad_recibida
      if (totalAsignado > datosArt.cantidad_recibida || totalAsignado < datosArt.cantidad_recibida) {
        setErrorCantidad(true);
      } else {
        setErrorCantidad(false);
      }
    }
  }, [stockPorTalles, datosArt.cantidad_recibida]);

  useEffect(() => {
    if (articuloSeleccionado && almacenSeleccionado) {
      if (articuloSeleccionado.tiene_talles === 1) {
        getData(`/stock_prendas/detalle/${almacenSeleccionado.id_almacen}/${articuloSeleccionado.id_articulo}`, setInventarioPrendas);
      }
    }
  }, [articuloSeleccionado, almacenSeleccionado])

  /* -------------------------------------------------------------------------------  */
  //Nuevo selector de proveedores
  const [loading, setLoading] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [proveedorSelected, setProveedorSelected] = useState();
  const [inputValue, setInputValue] = useState("");

  const getProveedores = async (busqueda) => {
    console.log("entro")
    if (!busqueda) return;

    setLoading(true);

    try {
      const res = await fetch(
        UrlApi + `/proveedores_padron/search?query=${encodeURIComponent(busqueda)}`
      );
      const data = await res.json();
      setProveedores(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOnChangeProvSel = async (e, proveedor) => {
    setProveedorSelected(proveedor);
    console.log(proveedor)
  }

  return (
    <>
      <Dialog
        open={dialogCrearArticulo}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
      >
        <Title
          titulo={`Ingresar Artículo a la Sucursal`}
          handleClose={() => {
            handleClose()
          }}
        />
        <form onSubmit={guardarCrear} autoComplete="off">
          <Box
            border={0.5}
            borderColor={grey[300]}
            backgroundColor="#F4F6F6"
            p={2}
            py={2}
            mt={1}
          >
            <DialogContent>
              <Grid container spacing={1}>
                <Grid item xs={articuloSeleccionado?.tiene_talles === 1 && (datosArt.cantidad_recibida !== null && datosArt.cantidad_recibida > 0) ? 9 : 12}>
                  <Grid container mb={1} spacing={1}>
                    <Grid item xs={6} py={1} mb={1}>
                      <Autocomplete
                        disabled={!props.articulos}
                        size="small"
                        focused
                        disableClearable
                        id="stock_articulos"
                        noOptionsText={"Artículo INEXISTENTE"}
                        options={props.articulos}
                        autoHighlight
                        getOptionLabel={(articulos) =>
                          articulos.nombre + "-" + articulos.descripcion
                        }
                        onChange={(event, value) =>
                          setArticuloSeleccionado(value)
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.nombre} - {option.descripcion}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            style={style}
                            focused
                            required
                            size="small"
                            placeholder="Escriba para buscar artículos..."
                            {...params}
                            label="Artículo"
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={6} py={1} mb={1}>
                      <Autocomplete
                        required
                        disableClearable
                        placeholder="Nombre, CUIT o Sisven ID"
                        options={proveedores}
                        value={proveedorSelected}
                        inputValue={inputValue}
                        open={
                          inputValue?.length >= 2 &&
                          (loading || proveedores.length > 0)
                        }
                        loading={loading}
                        loadingText={"Cargando..."}
                        noOptionsText=""
                        onChange={(e, value) => {
                          handleOnChangeProvSel(e, value);
                        }}
                        onInputChange={(e, value, reason) => {
                          setInputValue(value);

                          if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current);
                            timeoutRef.current = null;
                          }

                          if (value?.length >= 2) {
                            timeoutRef.current = setTimeout(() => {
                              getProveedores(value);
                              timeoutRef.current = null;
                            }, 300);
                          } else {
                            setProveedores([]);
                          }
                        }}
                        getOptionLabel={(option) =>
                          `${option?.denominacion?.trim()} (${option?.cuit})`
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.denominacion}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {`${option?.denominacion} (${option?.cuit}) `}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            focused
                            fullWidth
                            placeholder="Escriba para buscar proveedores..."
                            {...params}
                            variant="outlined"
                            size="small"
                            label="Proveedores"
                            required={proveedorSelected === null}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} py={1} mb={1}>
                      <Autocomplete
                        disabled={!props.almacenes}
                        size="small"
                        focused
                        disableClearable
                        id="stock_almacenes"
                        noOptionsText={"Almacén INEXISTENTE"}
                        options={props.almacenes}
                        autoHighlight
                        getOptionLabel={(almacenes) =>
                          almacenes.id_almacen + "-" + almacenes.nombre
                        }
                        onChange={(event, value) =>
                          setAlmacenSeleccionado(value)
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.id_almacen} - {option.nombre}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            style={style}
                            focused
                            required
                            size="small"
                            placeholder="Escriba para buscar almacenes..."
                            {...params}
                            label="Almacén"
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={8} mb={2}>
                      <TextField
                        style={style}
                        label="Detalle Transaccion"
                        name="detalle_transaccion"
                        size="small"
                        placeholder="..."
                        inputProps={{
                          maxLength: 60,
                        }}
                        focused
                        required
                        fullWidth
                        value={datosArt.detalle_transaccion}
                        onChange={almacenar}
                      />
                    </Grid>
                    <Grid item xs={2.8} mb={2}>
                      <TextField
                        style={style}
                        label="N° Pto.Venta"
                        name="nro_remito_puntodeventa"
                        size="small"
                        placeholder="0000"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 4,
                        }}
                        focused
                        required
                        fullWidth
                        value={datosArt.nro_remito_puntodeventa}
                        onChange={almacenar}
                      />
                    </Grid>
                    <Grid item xs={3} py={1} mb={1}>
                      <TextField
                        style={style}
                        label="N° Remito"
                        name="nro_remito_numero"
                        size="small"
                        placeholder="00000123"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 8,
                        }}
                        focused
                        required
                        fullWidth
                        value={datosArt.nro_remito_numero}
                        onChange={almacenar}
                      />
                    </Grid>
                    <Grid item xs={3.3} py={1} mb={1}>
                      <TextField
                        style={style}
                        label="Cantidad en el Inventario"
                        size="small"
                        placeholder={cantidadInventario}
                        value={inventario[0] ? inventario[0].cantidad : ""}
                        inputProps={{
                          readOnly: true,
                          "aria-label": "Without label",
                        }}
                        onChange={cantidadInventario}
                      />
                    </Grid>
                    <Grid item xs={2.9} py={1} mb={1}>
                      <TextField
                        style={style}
                        label="Cantidad"
                        name="cantidad_recibida"
                        size="small"
                        placeholder="..."
                        onKeyPress={(event) => {
                          if (!/[0-9.]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 6,
                        }}
                        focused
                        required
                        fullWidth
                        value={datosArt.cantidad_recibida}
                        onChange={almacenar}
                      />
                    </Grid>
                    <Grid item xs={3.7} py={1} mb={1}>
                      <TextField
                        style={style}
                        label="Fecha Transacción"
                        name="fecha_transaccion"
                        size="small"
                        type="date"
                        focused
                        required
                        fullWidth
                        value={moment(datosArt.fecha_transaccion).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={almacenar}
                      />
                    </Grid>
                    <Grid item xs={4} py={1} mb={1}>
                      <Button
                        onClick={() => setOpenCloseAdjDoc(!openCloseAdjDoc)}
                        variant="outlined"
                        size="medium"
                        startIcon={<AttachFileIcon />}
                      >
                        ADJUNTAR DOCUMENTACIÓN
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  {articuloSeleccionado?.tiene_talles === 1 && (datosArt.cantidad_recibida !== null && datosArt.cantidad_recibida > 0) && (
                    <Box
                      border={1}
                      borderColor={grey[400]}
                      borderRadius={2}
                      p={1}
                      backgroundColor="#FFFFFF"
                    >
                      <Typography
                        variant="h6"
                        align="center"
                      // gutterBottom
                      >
                        Stock Por Talles
                      </Typography>
                      <Box textAlign="center" >
                        <Typography variant="body1">
                          Total asignado: {stockPorTalles.reduce((sum, item) => sum + item.stock, 0)} / {datosArt.cantidad_recibida}
                        </Typography>
                      </Box>
                      <Box
                        borderRadius={2}
                        p={1}
                        backgroundColor="#FFFFFF"
                        maxHeight="150px"
                        overflow="auto"
                      >
                        <Grid container spacing={1}>
                          {talles.map((talle) => (
                            <Grid item xs={12} key={talle.id}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                border={1}
                                borderColor={grey[300]}
                                borderRadius={2}
                              >
                                <Typography variant="subtitle1" fontWeight="bold" display={"flex"} alignItems={"center"}>
                                  {talle.talle}
                                </Typography>
                                <TextField
                                  type="number"
                                  variant="outlined"
                                  size="small"
                                  value={stockPorTalles.find((item) => item.id === talle.id)?.stock || 0}
                                  onChange={(e) => handleStockChange(talle.id, e.target.value)}
                                  InputProps={{
                                    inputProps: { min: 0 },
                                  }}
                                  sx={{
                                    maxWidth: "100px",
                                    borderColor: errorCantidad ? 'red' : 'inherit', // Borde rojo en caso de error
                                    '& .MuiOutlinedInput-root': {
                                      '&.Mui-focused fieldset': {
                                        borderColor: errorCantidad ? 'red' : '', // Borde rojo cuando esté enfocado y haya error
                                      },
                                    },
                                  }}
                                />

                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Stack direction="row">
                <Grid container direction={{ xs: "column", sm: "row" }}>
                  <Grid item xs={8}>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                    >
                      Volver
                    </Button>
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                      disabled={errorCantidad} // Deshabilitar el botón si hay error
                    >
                      Guardar
                    </Button>

                  </Grid>
                </Grid>
              </Stack>
              {errorCantidad && (
                <Typography variant="body2" color="error" align="center">
                  La cantidad por talles debe ser igual a la cantidad total
                </Typography>
              )}
            </DialogContent>
          </Box>
        </form>
      </Dialog>
      {openCloseAdjDoc ? ( // ADJUNTAR COMPROBANTESss
        <FileUploadStock
          fileId={props.newUuidDoc}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdjDoc(false)} // Proporciona una función de cierre
        />
      ) : null}
      {/* GUARDAR AL CREAR */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  )
}

export default Dialog_ingresar